import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

export const ERROR_PAGE = 'error_page';

export const SP_ERROR_EVENTS = {
  ERROR_404_PAGE_LOADED: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: ERROR_PAGE,
    label: '404',
    name: 'error_404_page_loaded',
  }),
};
